// extracted by mini-css-extract-plugin
export default {"item":"waterbody_notifications_form__item--Nd6+","label":"waterbody_notifications_form__label--dGCx"};